import { injectReducer } from '../../store/reducers'

export default (store) => ({
  path: 'default-edit',

  getComponent(nextState, cb) {
    require.ensure([], require => {
      const DefaultEditContainer = require('./containers/DefaultEditContainer').default
      const DefaultEditReducer = require('./modules/defaultEdit').default

      injectReducer(store, {
        key: 'defaultEdit',
        reducer: DefaultEditReducer
      })

      cb(null, DefaultEditContainer)
    }, 'defaultEdit')
  }
})



// WEBPACK FOOTER //
// ./src/routes/DefaultEdit/index.js